import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { FxError, Headers, Queries, request } from "@coralblack/flax";
import { ApiErrorResponse, FxApiRequestData } from "@maven-rest/common/flax.types";

type BaseMutationOptions<TData, TError, TVariables, TContext> = {
  fnOption?: {
    fxApi: FxApiRequestData<TData>;
    query?: Queries;
    headers?: Headers;
  };
} & UseMutationOptions<TData, TError, TVariables, TContext>;

export const useBaseMutation = <
  TData = unknown,
  TError = FxError<ApiErrorResponse, ApiErrorResponse>,
  TVariables = void,
  TContext = unknown
>({
  fnOption,
  ...mutationOptions
}: BaseMutationOptions<TData, TError, TVariables, TContext>) => {
  return useMutation({
    mutationFn: fnOption?.fxApi
      ? async () => {
          const resp = await request({ ...fnOption.fxApi, query: fnOption.query, headers: fnOption.headers });

          return resp.data;
        }
      : mutationOptions.mutationFn,
    ...mutationOptions,
  });
};
